export default __webpack_public_path__ + "static/media/profile2.56e19824.jpg";